// Squarespace RSS Feed Parser
// This fetches content from your Squarespace RSS feed

const RSS_URL = 'https://pineapple-icosahedron-gxdt.squarespace.com/blog?format=rss';

class SquarespaceRSS {
  constructor() {
    this.corsProxy = 'https://api.allorigins.win/get?url=';
  }

  // Fetch blog posts from RSS feed
  async getBlogPosts(limit = 10) {
    try {
      const proxyUrl = `${this.corsProxy}${encodeURIComponent(RSS_URL)}`;
      const response = await fetch(proxyUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.contents) {
        throw new Error('No content received from RSS feed');
      }
      
      // Parse the XML content
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data.contents, "text/xml");
      
      const items = xmlDoc.querySelectorAll("item");
      const posts = Array.from(items).slice(0, limit).map((item, index) => ({
        id: index + 1,
        title: item.querySelector("title")?.textContent || "",
        link: item.querySelector("link")?.textContent || "",
        excerpt: item.querySelector("description")?.textContent || "",
        content: item.querySelector("description")?.textContent || "",
        author: item.querySelector("author")?.textContent || "Anonymous",
        date: item.querySelector("pubDate")?.textContent || new Date().toISOString(),
        category: "General",
        categoryName: "General",
        image: this.extractImageFromContent(item.querySelector("description")?.textContent || ""),
        slug: this.generateSlug(item.querySelector("title")?.textContent || "")
      }));
      
      return posts;
    } catch (error) {
      console.error('Error fetching RSS feed:', error);
      return [];
    }
  }

  // Extract image from content (if any)
  extractImageFromContent(content) {
    const imgMatch = content.match(/<img[^>]+src="([^"]+)"/);
    return imgMatch ? imgMatch[1] : null;
  }

  // Generate slug from title
  generateSlug(title) {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  // Get site info from RSS
  async getSiteInfo() {
    try {
      const proxyUrl = `${this.corsProxy}${encodeURIComponent(RSS_URL)}`;
      const response = await fetch(proxyUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data.contents, "text/xml");
      
      const channel = xmlDoc.querySelector("channel");
      return {
        title: channel?.querySelector("title")?.textContent || "Your Site",
        description: channel?.querySelector("description")?.textContent || "",
        link: channel?.querySelector("link")?.textContent || ""
      };
    } catch (error) {
      console.error('Error fetching site info:', error);
      return {
        title: "Your Site",
        description: "Creating exceptional digital experiences",
        link: "https://pineapple-icosahedron-gxdt.squarespace.com"
      };
    }
  }
}

export const squarespaceRSS = new SquarespaceRSS();
export default squarespaceRSS; 